import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { RLAdvancedSearchController } from "./advanced-search";


export interface IRLAdvancedSearchCriteriaScope extends ng.IScope {
    group: Models.ISearchGroup;
    editMode: boolean;
}

export function RLAdvancedSearchCriteria(): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/advanced-search-criteria.html"),
        //scope: true,
        scope: {
            group: "=group",
            editMode: "=editMode"
        },
        controller: RLAdvancedSearchCriteriaController,
        controllerAs: 'ascVM',
        bindToController: true,
        require: ["rlAdvancedSearchCriteria", "^rlAdvancedSearch"],
        link: (scope: IRLAdvancedSearchCriteriaScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var advancedSearchCriteriaController: RLAdvancedSearchCriteriaController = controllers[0];
            var advancedSearchController: RLAdvancedSearchController = controllers[1];
            advancedSearchCriteriaController.advancedSearchController = advancedSearchController;
            return;
        }
    }
}

export class RLAdvancedSearchCriteriaController {
    static $inject = ['$scope', '$timeout', '$window', "$q"];

    public group: Models.ISearchGroup;
    public advancedSearchController: RLAdvancedSearchController;
    private relationships: Models.ICharacteristicType[];
    private charMetadata: Models.ITemplateCharacteristicMetaData[];
    private comparators: { [id: number]: string };
    public editMode: boolean;

    constructor(
        private $scope: IRLAdvancedSearchCriteriaScope,
        private $timeout: ng.ITimeoutService,
        private $window: ng.IWindowService,
        private $q: ng.IQService) {
        return;
    }

    public get charMetaDatas(): Models.ITemplateCharacteristicMetaData[] {
        if (!this.charMetadata) {
            this.charMetadata = [];
            this.advancedSearchController.getCharMetaData(this.group.operations[0].charTypeID)
                .then((res) => {
                    this.charMetadata = res;
                    if (!this.editMode) {
                        this.group.operations[0].characteristicMetaData[0] = res[0].characteristicMetaData;
                    }
                    else {
                        var criteriaMTD = _.find(res, r => r.characteristicMetaData.characteristicID == this.group.operations[0].characteristicMetaData[0].characteristicID);
                        this.comparators = this.advancedSearchController.getComparators(criteriaMTD.characteristicMetaData);
                        this.group.operations[0].characteristicMetaData[0] = criteriaMTD.characteristicMetaData;
                    }
                });
        }
        return this.charMetadata;
    }

    public get relationshipTypes(): Models.ICharacteristicType[] {
        if (!this.relationships) {
            this.relationships = this.advancedSearchController.getRelationships(this.group.operations[0].charTypeID);
        }
        return this.relationships;
    }

    public getOperations(operation: Models.ISearchOperation): { [id: number]: string } {
        if (!this.comparators) {
            this.comparators = [];
            this.comparators = this.advancedSearchController.getComparators(operation.characteristicMetaData[0]);
        }
        return this.comparators;
    }

    // --------------------------------------------------------------------------------

    private getFirstComparator(comparators: { [id: number]: string }): number {
        return this.advancedSearchController.getFirstComparator(comparators);
    }

    // --------------------------------------------------------------------------------

    // Changed: data source
    public OnCharTypeChanged(charTypeID: number, operation: Models.ISearchOperation) {
        this.comparators = [];
        this.charMetadata = [];
        this.advancedSearchController.getCharMetaData(charTypeID)
            .then((res) => {
                this.charMetadata = res;
                var hasValidCharMetadata: boolean = ((res != null) && (res.length > 0) && (res[0] != null) && (res[0].characteristicMetaData != null));
                if (!hasValidCharMetadata) {
                    throw Error("Char metadata is not valid for charTypeID = " + charTypeID);
                }
                else {
                    this.advancedSearchController.selectedCharTypeID = charTypeID;
                    operation.characteristicMetaData = [res[0].characteristicMetaData];
                    this.comparators = this.advancedSearchController.getComparators(this.charMetadata[0].characteristicMetaData);
                    operation.comparator = this.getFirstComparator(this.comparators);
                }
            });
        return;
    }

    // Changed: field
    // TODO: when the field changes, clear out any existing values entered
    public OnCharMetadataChanged(operation: Models.ISearchOperation) {
        var metadata = operation.characteristicMetaData[0];
        if (metadata) {
            // - refresh value fields                
            // can't really explain why this is necessary. something to do with dirty checking and the way char-data-element was written.                
            operation.charDatas = [];
            operation.charDatas = this.advancedSearchController.getEmptyCharData(metadata);
            operation.betweenCharDatas = [];
            operation.betweenCharDatas = this.advancedSearchController.getEmptyCharData(metadata);
            // - reload comparers                
            this.comparators = this.advancedSearchController.getComparators(operation.characteristicMetaData[0]);
            operation.comparator = this.getFirstComparator(this.comparators);
        }
        return;
    }

    // Changed: operator
    public OnComparatorChanged(operation: Models.ISearchOperation) {
        if (operation.characteristicMetaData[0] != null) {
            if (operation.comparator != Consts.AdvancedSearch.Comparator.Between) {
                if (operation.charDatas.length > 1 && operation.betweenCharDatas.length > 0) {
                    operation.charDatas.splice(1, 1);
                    operation.betweenCharDatas = [];
                }
            }
        }
        return;
    }

    public OnDeleteOperation(operation: Models.ISearchOperation) {
        var operationToDelete = _.find(this.group.operations, op => op == operation);
        if (operationToDelete) {
            _.remove(this.group.operations, op => op == operation);
        }
    }
}
